// extracted by mini-css-extract-plugin
export default {"block-white":"BackgroundBlock_block-white__IojZv","block-black":"BackgroundBlock_block-black__dcNtL"};